import { useState, useEffect } from "react";
import './nikshay.css';
import { nikshayAPI } from "../../../services/nikshay.api";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { getNikshayUsername } from "../../../utils/nikshayLocalStorage";

const NewRegistrationNikshay = ({ onClose, onRegistrationSuccess }) => {

    // Risk factor checkboxes
    const [checkedItems, setCheckedItems] = useState({
        antiTNF: false,
        BronchialAsthma: false,
        Cancer: false,
        CardiovascularDiscorder: false,
        TBPatients: false,
        COPD: false,
        covidRecovery: false,
        Diabetes: false,
        Dialysis: false,
        HealthCareWorker: false,
        Hypertensive: false,
        LactatingMother: false,
        LiverImpairment: false,
        Migrant: false,
        Miner: false,
        PalliativeCare: false,
        Patientimmunsuppressants: false,
        Preanancv: false,
        NotApplicable: true,
        Prison: false,
        IllegalImmigrant: false,
        RenalImpairment: false,
        Transplantation: false,
        UrbanSlum: false,
        BCGVaccination: false,
        Undernourished: false,
        Elderly: false,
        WorkplaceSettings: false,
        TeaGardenWorker: false,
        ConstructionSiteWorker: false,
        CongregateSettings: false,
        DeaddictionCenters: false,
        IndoorPollution: false,
        MarginalizedHIV: false,
        LGBTQAI: false,
        SubstanceAbuse: false,
        TobaccoSmoker: false,
        SilicaExposure: false,
        Other: false,
    });

    const handleChange = (e) => {
        const { name, checked } = e.target;
        if (name === "NotApplicable") {
            const newState = {};
            for (let key in checkedItems) {
                newState[key] = key === "NotApplicable" ? checked : false;
            }
            setCheckedItems(newState);
        } else {
            setCheckedItems({
                ...checkedItems,
                [name]: checked,
                NotApplicable: false,
            });
        }
    };

    const isNotApplicableChecked = checkedItems.NotApplicable;
    const anyOtherChecked = Object.keys(checkedItems).some(
        (key) => key !== "NotApplicable" && checkedItems[key]
    );

    // Symptoms checkboxes
    const [checkedSymptoms, setCheckedSymptoms] = useState({
        symptom_Asymptomatic: true,
        symptom_twoWeeks: false,
        symptom_upblood: false,
        symptom_fever: false,
        symptom_weightLoss: false,
        symptom_chestPain: false,
        symptom_Shortnessbreath: false,
        symptom_Fatigue: false,
        symptom_FailureGainWeight: false,
        symptom_DecreasedActivity: false,
        symptom_others: false,
    });

    const handleSymptomChange = (e) => {
        const { name, checked } = e.target;
        if (name === "symptom_Asymptomatic") {
            const newState = {};
            for (let key in checkedSymptoms) {
                newState[key] = key === "symptom_Asymptomatic" ? checked : false;
            }
            setCheckedSymptoms(newState);
        } else {
            setCheckedSymptoms({
                ...checkedSymptoms,
                [name]: checked,
                symptom_Asymptomatic: false,
            });
        }
    };

    const isAsymptomaticChecked = checkedSymptoms.symptom_Asymptomatic;

    const calculateAge = (birthDate) => {
        if (!birthDate) return 0; // Return 0 if birthDate is not provided
        const birthDateObj = new Date(birthDate);
        const today = new Date();
        let age = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();
        const dayDiff = today.getDate() - birthDateObj.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }
        return age;
    };



    // Only alphabets fields
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        fatherName: '',
    });

    const handleChangename = (e) => {
        const { name, value } = e.target;
        // Allow spaces for fatherName, only alphabets for firstName and lastName
        const regex = name === 'fatherName' ? /^[a-zA-Z ]*$/ : /^[a-zA-Z]*$/;
        if (regex.test(value)) {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // Phones
    const [phones, setPhones] = useState({
        primary: "",
        secondary1: "",
        secondary2: "",
        secondary3: ""
    });
    const handlePhoneChange = (e) => {
        const { name, value } = e.target;
        if (/^\d{0,10}$/.test(value)) {
            setPhones((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // Address fields
    const [addressFields, setAddressFields] = useState({
        address: "",
        taluka: "",
        landmark: "",
        healthFacility: "",
        village: ""
    });
    const handleAddressChange = async (e) => {
        const { name, value } = e.target;
        setAddressFields((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === 'healthFacility' && value) {
            try {
                setIsLoading(true);
                const villageData = await nikshayAPI.getVillages(value);
                setVillages(villageData?.data || []);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load villages');
            }
        }
    };

    // Demographic fields
    const [demographicFields, setDemographicFields] = useState({
        area: "Unknown",
        maritalStatus: "Unknown",
        occupation: "Unknown",
        socioeconomicStatus: "Unknown",
        gender: "",
        dob: ""
    });
    const handleDemographicChange = (e) => {
        const { name, value } = e.target;
        setDemographicFields((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Informant fields
    const [informant, setInformant] = useState({
        name: "",
        designation: ""
    });
    const handleInformantChange = (e) => {
        const { name, value } = e.target;
        setInformant((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Contact person fields
    const [contactPerson, setContactPerson] = useState({
        name: "",
        phone: "",
        address: ""
    });
    const handleContactPersonChange = (e) => {
        const { name, value } = e.target;
        setContactPerson((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Pincode and age
    const [pincode, setPincode] = useState('');
    const handlePincodeChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,6}$/.test(value)) {
            setPincode(value);
        }
    };
    const [age, setAge] = useState("");
    const [hivStatus, setHivStatus] = useState("Unknown");
    const [vaccinationDate, setVaccinationDate] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPhiModal, setShowPhiModal] = useState(false);

    // Modal-specific temporary states
    const [tempState, setTempState] = useState("");
    const [tempDistrict, setTempDistrict] = useState("");
    const [tempTu, setTempTu] = useState("");
    const [tempHealthFacility, setTempHealthFacility] = useState("");
    const [tempDistricts, setTempDistricts] = useState([]);
    const [tempTuList, setTempTuList] = useState([]);
    const [tempFacilities, setTempFacilities] = useState([]);

    // Modal final selections (isolated from Residence Details)
    const [modalState, setModalState] = useState("");
    const [modalDistrict, setModalDistrict] = useState("");
    const [modalTu, setModalTu] = useState("");
    const [modalHealthFacility, setModalHealthFacility] = useState("");
    const [modalFacilities, setModalFacilities] = useState([]);

    const [nikshayuserType, setNikshayuserType] = useState("");

    useEffect(() => {
        if (showPhiModal) {
            setTempState(selectedState);
            setTempDistrict(selectedDistrict);
            setTempTu(""); // do not auto-select TU inside modal
            setTempHealthFacility(""); // do not auto-select PHI inside modal
            setTempDistricts(districts);
            setTempTuList(tuList);
            setTempFacilities([]);
        }
    }, [showPhiModal]);

    const handleTempStateChange = async (e) => {
        const stateId = e.target.value;
        setTempState(stateId);
        setTempDistrict("");
        setTempTu("");
        setTempHealthFacility("");
        setTempDistricts([]);
        setTempTuList([]);
        setTempFacilities([]);

        if (stateId) {
            try {
                setIsLoading(true);
                const districtData = await nikshayAPI.getDistrict(stateId);
                const filteredDistrictData = (districtData?.data || []).filter(tu => tu.type !== "STATE");
                setTempDistricts(filteredDistrictData);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load districts');
            }
        }
    };

    const handleTempDistrictChange = async (e) => {
        const districtId = e.target.value;
        setTempDistrict(districtId);
        setTempTu("");
        setTempHealthFacility("");
        setTempTuList([]);
        setTempFacilities([]);

        if (districtId) {
            try {
                setIsLoading(true);
                const tuData = await nikshayAPI.getTuList(districtId);
                const filteredTuList = (tuData?.data || []).filter(tu => tu.type === "TU");
                setTempTuList(filteredTuList);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load TU list');
            }
        }
    };

    const handleTempTuChange = async (e) => {
        const tuId = e.target.value;
        setTempTu(tuId);
        setTempHealthFacility("");
        setTempFacilities([]);

        if (tuId) {
            try {
                setIsLoading(true);
                const facilitiesData = await nikshayAPI.getFacilities(tuId);
                const filteredFacilityData = (facilitiesData?.data || []).filter(tu => tu.type !== "TU");
                setTempFacilities(filteredFacilityData);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load facilities');
            }
        }
    };

    const handleTempPhiChange = (e) => {
        setTempHealthFacility(e.target.value);
    };

    const handlePhiModalDone = () => {
        setModalState(tempState);
        setModalDistrict(tempDistrict);
        setModalTu(tempTu);
        setModalHealthFacility(tempHealthFacility);
        setModalFacilities(tempFacilities);

        // Keep parent State and District in sync
        setSelectedState(tempState);
        setSelectedDistrict(tempDistrict);
        setDistricts(tempDistricts);
        setTuList(tempTuList);

        // DO NOT update parent selectedTu or addressFields.healthFacility
        setShowPhiModal(false);
    };

    // State/District/TU/Facilities/Villages
    const [selectedState, setSelectedState] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedTu, setSelectedTu] = useState('');
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [tuList, setTuList] = useState([]);
    const [facilities, setFacilities] = useState([]);
    const [villages, setVillages] = useState([]);
    const [informantDetails, setInformantDetails] = useState([]);

    const [personFrom, setPersonFrom] = useState("IndiaTbPublic"); // default
    const [caseFinding, setCaseFinding] = useState("Passive (Routine programme)"); // default
    const [healthId, setHealthId] = useState("");
    const [healthAddress, setHealthAddress] = useState("");

    const handleStateChange = async (e) => {
        const stateId = e.target.value;
        setSelectedState(stateId);
        setSelectedDistrict('');
        setSelectedTu('');
        setTuList([]);
        setFacilities([]);
        setDistricts([]);

        if (stateId) {
            try {
                setIsLoading(true);
                const districtData = await nikshayAPI.getDistrict(stateId);
                const fileteredDistrictData = (districtData?.data || []).filter(tu => tu.type !== "STATE");
                setDistricts(fileteredDistrictData);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load districts');
            }
        }
    };

    const handleDistrictChange = async (e) => {
        const districtId = e.target.value;
        setSelectedDistrict(districtId);
        setSelectedTu('');
        setFacilities([]);

        if (districtId) {
            try {
                setIsLoading(true);
                const tuData = await nikshayAPI.getTuList(districtId);
                const filteredTuList = (tuData?.data || []).filter(tu => tu.type === "TU");
                setTuList(filteredTuList);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load TU list');
            }
        } else {
            setIsLoading(false);
            setTuList([]);
        }
    };

    const handleTuChange = async (e) => {
        const tuId = e.target.value;
        setSelectedTu(tuId);

        if (tuId) {
            try {
                setIsLoading(true);
                const facilitiesData = await nikshayAPI.getFacilities(tuId);
                const filteredFacilityData = (facilitiesData?.data || []).filter(tu => tu.type !== "TU");
                setFacilities(filteredFacilityData);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                toast.error('Failed to load facilities');
            }
        } else {
            setIsLoading(false);
            setFacilities([]);
        }
    };

    // Load data on component mount
    useEffect(() => {

        const userDetails = localStorage.getItem("orignalBeneficiaryData");
        if (userDetails) {
            try {

                const abhaData = JSON.parse(userDetails);
                let calculatedAge;

                let formattedDob = "";
                if (abhaData?.dob) {
                    const [day, month, year] = abhaData.dob.split('-');
                    calculatedAge = calculateAge(new Date(`${year}-${month}-${day}`));
                    formattedDob = `${year}-${month}-${day}`;
                }

                const nameParts = (abhaData.name || "").split(' ');
                const firstName = nameParts[0] || "";
                const lastName = nameParts.slice(1).join(' ') || "";

                if (abhaData.hid) {
                    setHealthId(abhaData.hidn);
                }
                if (abhaData.hidn) {
                    setHealthAddress(abhaData.hid);
                }

                setFormData(prev => ({
                    ...prev,
                    firstName: firstName,
                    lastName: lastName
                }));

                const abha_gender = abhaData?.gender
                    ? abhaData.gender.toUpperCase() === "M" ||
                        abhaData.gender.toUpperCase() === "MALE"
                        ? "Male"
                        : abhaData.gender.toUpperCase() === "F" ||
                            abhaData.gender.toUpperCase() === "FEMALE"
                            ? "Female"
                            : abhaData.gender
                    : "";

                setDemographicFields(prev => ({
                    ...prev,
                    dob: formattedDob,
                    gender: abha_gender
                }));

                setPhones(prev => ({
                    ...prev,
                    primary: abhaData?.mobile && !abhaData.mobile.includes("X") ? abhaData.mobile : ""
                }));

                setAge(calculatedAge);

            } catch (parseError) {
                console.error('Error parsing localStorage data:', parseError);
            }
        }

        const loadData = async () => {
            setIsLoading(true);

            try {

                const storedUser = JSON.parse(
                    localStorage.getItem("NIKSHAY_loggedinUserdetails")
                );

                let hierarchyId = null;

                // ✅ First check direct hierarchyId
                if (storedUser?.hierarchyId) {
                    hierarchyId = storedUser.hierarchyId;
                } else if (storedUser?.response_login_api) {
                    // ✅ fallback from response_login_api
                    const parsedResponse = JSON.parse(storedUser.response_login_api);
                    hierarchyId = parsedResponse?.data?.user?.hierarchyId;
                }

                if (!hierarchyId) {
                    toast.error("HierarchyId not found");
                    return;
                }

                // ✅ use hierarchyId
                const userDetails = await nikshayAPI.getUserDetailsWithHierarchy(hierarchyId);

                setNikshayuserType(userDetails?.type || "");

                // const informantDetails = await nikshayAPI.getInformant(hierarchyId);

                // setInformantDetails(informantDetails?.data || []);

                if (userDetails?.level2Id) {
                    const stateResponse = await nikshayAPI.getState();
                    const stateList = (stateResponse?.data || []).filter(tu => tu.type !== "COUNTRY");
                    setStates(stateList);
                    setSelectedState(userDetails?.level2Id);
                }

                if (userDetails?.level3Id) {
                    const districtData = await nikshayAPI.getDistrict(userDetails?.level2Id);
                    const districtList = (districtData?.data || []).filter(tu => tu.type !== "STATE");
                    setDistricts(districtList);
                    setSelectedDistrict(userDetails?.level3Id);
                }

                if (userDetails?.level3Id) {
                    const tuData = await nikshayAPI.getTuList(userDetails?.level3Id);
                    const filteredTuList = (tuData?.data || []).filter(tu => tu.type === "TU");
                    setTuList(filteredTuList);
                    setSelectedTu(userDetails?.level4Id);
                }

                if (userDetails?.level4Id) {
                    const facilitiesData = await nikshayAPI.getFacilities(userDetails?.level4Id);
                    const filteredFAcilityList = (facilitiesData?.data || []).filter(tu => tu.type !== "TU");
                    setFacilities(filteredFAcilityList);
                }

            } catch (error) {
                console.error("loadData error:", error);
                toast.error("Failed to load State, District, TU and Facility data.");
            } finally {
                setIsLoading(false);
            }
        };

        loadData();

    }, []);


    // Validation function
    const validateForm = () => {
        const errors = [];

        if (!formData.firstName.trim()) errors.push("First name is required");
        if (!formData.lastName.trim()) errors.push("Last name is required");
        if (!demographicFields.gender) errors.push("Gender is required");
        if (!addressFields.address.trim()) errors.push("Address is required");
        if (!addressFields.taluka.trim()) errors.push("Taluka/Block is required");

        return errors;
    };

    // Submit handler with dynamic payload
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form
        const validationErrors = validateForm();
        if (validationErrors.length > 0) {
            toast.error(validationErrors.join(", "));
            return;
        }

        const symptomMap = {
            symptom_twoWeeks: "Cough for more than 2 weeks",
            symptom_upblood: "Coughing up blood",
            symptom_fever: "Fever",
            symptom_weightLoss: "Weight loss",
            symptom_chestPain: "Chest Pain",
            symptom_Shortnessbreath: "Shortness of breath",
            symptom_Fatigue: "Fatigue",
            symptom_FailureGainWeight: "Failure to gain weight (in children)",
            symptom_DecreasedActivity: "Decreased activity or playfulness (in children)",
            symptom_others: "Others",
            symptom_Asymptomatic: "Asymptomatic",
        };

        const riskLabelMap = {
            antiTNF: "Anti-TNF treatment",
            BronchialAsthma: "Bronchial Asthma",
            Cancer: "Cancer",
            CardiovascularDiscorder: "Cardiovascular Disorder",
            TBPatients: "Contact of Known TB Patients",
            COPD: "COPD",
            covidRecovery: "COVID recovered patients",
            Diabetes: "Diabetes",
            Dialysis: "Dialysis",
            HealthCareWorker: "Health Care Worker",
            Hypertensive: "Hypertensive",
            LactatingMother: "Lactating Mother",
            LiverImpairment: "Liver Impairment",
            Migrant: "Migrant",
            Miner: "Miner",
            PalliativeCare: "Palliative Care",
            Patientimmunsuppressants: "Patient on immunosuppressants",
            Preanancv: "Pregnancy",
            Prison: "Prison",
            IllegalImmigrant: "Illegal Immigrant",
            RenalImpairment: "Renal Impairment",
            Transplantation: "Transplantation",
            UrbanSlum: "Urban Slum",
            BCGVaccination: "H/o Adult BCG Vaccination",
            Undernourished: "Undernourished / Malnourished (BMI <18.5 kg/m2)",
            Elderly: "Elderly (age >60 years)",
            WorkplaceSettings: "Workplace settings (coal/ sandblasting/ brick kiln)",
            TeaGardenWorker: "Tea garden worker",
            ConstructionSiteWorker: "Construction site worker",
            CongregateSettings: "Congregate settings",
            DeaddictionCenters: "Attendees of de-addiction centers",
            IndoorPollution: "Person exposed to indoor air pollution",
            MarginalizedHIV: "Marginalized populations at risk of HIV",
            LGBTQAI: "LGBTQAI++",
            SubstanceAbuse: "Substance abuse (alcoholic/ intravenous drug users)",
            TobaccoSmoker: "Tobacco/smoker",
            SilicaExposure: "Silica exposure/silicosis",
            Other: "Other"
        };

        const selectedSymptoms = Object.entries(checkedSymptoms)
            .filter(([_, checked]) => checked)
            .map(([key]) => symptomMap[key])
            .join(",");

        const riskMap = {
            MarginalizedHIV: "Marginalized populations at risk of HIV",
            IndoorPollution: "Person exposed to indoor air pollution",
        };


        const selectedRisks = Object.entries(checkedItems)
            .filter(([key, checked]) => checked && key !== "NotApplicable")
            .map(([key]) => riskLabelMap[key])
            .join(",");

        // Get current date in DD-MM-YYYY format
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;


        const storedUser = JSON.parse(
            localStorage.getItem("NIKSHAY_loggedinUserdetails")
        );

        let hierarchyId = null;

        // ✅ First check direct hierarchyId
        if (storedUser?.hierarchyId) {
            hierarchyId = storedUser.hierarchyId;
        } else if (storedUser?.response_login_api) {
            // ✅ fallback from response_login_api
            const parsedResponse = JSON.parse(storedUser.response_login_api);
            hierarchyId = parsedResponse?.data?.user?.hierarchyId;
        }


        // const nikshayloggenINDetails = JSON.parse(localStorage.getItem("NIKSHAY_loggedinUserdetails"));
        // const loginApiResponse = JSON.parse(nikshayloggenINDetails.response_login_api);
        // const hierarchyId = loginApiResponse.data.user.hierarchyId;

        // console.log(selectedRisks); return false;

        const finalHealthFacility = addressFields.healthFacility;
        const finalState = selectedState;
        const finalDistrict = selectedDistrict;
        const finalTu = selectedTu;

        const selHierarchyId = nikshayuserType !== "PHI" ? modalHealthFacility : addressFields.healthFacility;

        const residenceHierarchy = [
            1, // Country ID (fixed)
            parseInt(finalState) || null,
            parseInt(finalDistrict) || null,
            parseInt(finalTu) || null,
            parseInt(finalHealthFacility) || null,
            parseInt(addressFields.village) || null,
        ].filter(Boolean); // remove null values

        const residenceHierarchyId =
            parseInt(addressFields.village) ||
            parseInt(finalHealthFacility) ||
            parseInt(finalTu);

        const payload = {
            eventName: "ADD_PATIENT",
            data: {
                TypeOfPatient: personFrom,
                Stage: "PRESUMPTIVE_OPEN",
                RegistrationDate: formattedDate,
                // SelectedHierarchyId: hierarchyId,
                SelectedHierarchyId: parseInt(selHierarchyId),
                FirstName: formData.firstName || "",
                LastName: formData.lastName || "",
                FathersName: formData.fatherName || "",
                Age: parseInt(age) || null,
                Gender: demographicFields.gender || "",
                PrimaryPhone: phones.primary || "",
                SecondaryPhone1: phones.secondary1 || null,
                SecondaryPhone2: phones.secondary2 || null,
                SecondaryPhone3: phones.secondary3 || null,
                Address: addressFields.address || "",
                Ward: null,
                Taluka: addressFields.taluka || "",
                Landmark: addressFields.landmark || null,
                ResidenceHierarchyId: residenceHierarchyId,
                ResidenceHierarchyAll: residenceHierarchy,
                Pincode: pincode || null,
                Area: demographicFields.area,
                MaritalStatus: demographicFields.maritalStatus,
                Occupation: demographicFields.occupation,
                SocioeconomicStatus: demographicFields.socioeconomicStatus,
                KeyPopulation: selectedRisks || "Not Applicable",
                VaccinationDate: vaccinationDate || null,
                Symptom: selectedSymptoms || "Asymptomatic",
                HIVStatus: hivStatus || "Unknown",
                ContactPersonPhone: contactPerson.phone || null,
                ContactPersonName: contactPerson.name || null,
                ContactPersonAddress: contactPerson.address || null,
                parentEpisodeId: null,
                IsPossibleDuplicate: false,
                Source: null,
                SourcePatientId: null,
                TypeOfCaseFinding: caseFinding,
                DateOfBirth: demographicFields.dob || null,
                FollowUpsDone: [],
                TbWinReferenceId: null,
                InformantId: null,
                InformantName: informant.name || null,
                InformantDesignation: informant.designation || null,
                healthId: healthId || null,
                healthAddress: healthAddress || null
            },
        };

        setIsLoading(true);
        try {
            const resp = await nikshayAPI.registerPatient(getNikshayUsername(), payload);

            if (resp.Success && resp.callBackRecord?.status == 1) {

                const responseData = JSON.parse(resp.callBackRecord.json_received.Data.Response);
                const patientId = responseData.Id;
                toast.success(`Patient registered successfully! Patient ID: ${patientId}`);

                localStorage.setItem('nikshay_patient_id', patientId);

                localStorage.removeItem("NIKSHAY_NEW_PROFILE");

                // Notify parent component
                onRegistrationSuccess();

                setTimeout(() => {
                    onClose('handleCloseNikshayresistation');
                }, 1000); // 1 second delay

            } else if (resp.callBackRecord?.status == 0) {
                toast.error(resp.callBackRecord?.json_received.Data?.Response);
            } else {
                toast.error("Something went wrong during registration. Please try again.");
            }

            // Reset form or close modal here if needed
        } catch (error) {
            console.error("Registration failed:", error);
            if (error.response?.status === 403) {
                toast.error("Access denied. Please check your authentication or permissions.");
            } else if (error.response?.status === 400) {
                toast.error("Invalid data. Please check all required fields.");
            } else {
                toast.error("Registration failed. Please try again.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading && <Loader />}
            <div className="newRegistrationNikshay">
                <form onSubmit={handleSubmit}>
                    <div className="patientDetailsTitleHeader-h d-flex mb-0">
                        <div className="leftHeaderBar">
                            <h4><span><img src={"/images/nikshayicon.svg"} alt="" style={{ width: "60px", marginRight: "15px" }} /></span>
                                Ni-kshay Registration</h4>
                        </div>
                        <div className="closeDive nikshayclose" onClick={() => onClose('handleCloseNikshayresistation')}><img src="/images/closing.svg" alt="Close" /></div>
                    </div>

                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Person Sector</h5>
                            {/* <button>Is this case already enrolled?</button> */}
                        </div>
                        <div className="nikFeildsBody">
                            <div className="row">
                                <div className="col-xs-12 col-md-6">
                                    <div className="feild">
                                        <label>I want to Add a Person from<span className="mandate_field">*</span></label>
                                        <div className="radioProfile">
                                            <label>
                                                <input type="radio" name="personFrom" value="IndiaTbPublic" onChange={(e) => setPersonFrom(e.target.value)} defaultChecked disabled={nikshayuserType && nikshayuserType === "PHI"} />
                                                <span>Public Sector</span>
                                            </label>
                                            <label>
                                                <input type="radio" name="personFrom" value="IndiaTbPrivate" onChange={(e) => setPersonFrom(e.target.value)} disabled={nikshayuserType && nikshayuserType === "PHI"} />
                                                <span>Private Sector</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <div className="feild">
                                        <label>Type of Case Finding<span className="mandate_field">*</span></label>
                                        <div className="radioProfile">
                                            <label>
                                                <input type="radio" name="casefindin" value="Passive (Routine programme)" onChange={(e) => setCaseFinding(e.target.value)} defaultChecked />
                                                <span>Passive (Routine programme)</span>
                                            </label>
                                            <label>
                                                <input type="radio" name="casefindin" value="Active (Active case Finding)" onChange={(e) => setCaseFinding(e.target.value)} />
                                                <span>Active (Active case Finding)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Basic Details</h5>
                        </div>
                        <div className="nikFeildsBody">

                            {nikshayuserType && nikshayuserType !== "PHI" && (
                                <div className="row mb-3">
                                    <div className="col-xs-12 col-md-12">
                                        <h6><b>{personFrom === "IndiaTbPublic" ? "Public PHI" : "Private Facility"} <span className="mandate_field">*</span></b></h6>
                                        {modalHealthFacility ? (
                                            <div className="selected-phi-container p-3 rounded" style={{ background: '#f8f9fa', borderLeft: '4px solid #28a745', borderTop: '1px solid #e9ecef', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                                                <p className="mb-1 text-success font-weight-bold" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                                    <strong>{personFrom === "IndiaTbPublic" ? "Selected Public PHI:" : "Selected Private Facility:"}</strong>
                                                </p>
                                                <p className="mb-2" style={{ fontSize: '15px', color: '#333' }}>
                                                    {states.find(s => String(s.id) === String(modalState))?.name || "N/A"} &gt;{' '}
                                                    {districts.find(d => String(d.id) === String(modalDistrict))?.name || "N/A"} &gt;{' '}
                                                    {tuList.find(t => String(t.id) === String(modalTu))?.name || "N/A"} &gt;{' '}
                                                    {modalFacilities.find(f => String(f.id) === String(modalHealthFacility))?.name || "N/A"}
                                                </p>
                                                <a href="#" className="text-primary font-weight-bold" style={{ textDecoration: 'none', fontWeight: '600' }} onClick={(e) => { e.preventDefault(); setShowPhiModal(true); }}>
                                                    Click to change selection
                                                </a>
                                            </div>
                                        ) : (
                                            <div className="unselected-phi-container p-3 rounded" style={{ background: '#f8f9fa', borderLeft: '4px solid #dc3545', borderTop: '1px solid #e9ecef', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                                                <p className="mb-1 text-danger font-weight-bold" style={{ fontSize: '14px', fontWeight: 'bold' }}>Not Selected</p>
                                                <a href="#" className="text-primary font-weight-bold" style={{ textDecoration: 'none', fontWeight: '600' }} onClick={(e) => { e.preventDefault(); setShowPhiModal(true); }}>
                                                    Click to select
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>First name<span className="mandate_field">*</span></label>
                                        <input type="text"
                                            name="firstName"
                                            className="form-control form-text-control"
                                            value={formData.firstName}
                                            onChange={handleChangename} />
                                        {!formData.firstName.trim() && <p className="error">This field is required</p>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Middle & last Name<span className="mandate_field">*</span></label>
                                        <input type="text"
                                            name="lastName"
                                            className="form-control form-text-control"
                                            value={formData.lastName}
                                            onChange={handleChangename} />
                                        {!formData.lastName.trim() && <p className="error">This field is required</p>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Father/Husband Name</label>
                                        <input type="text"
                                            name="fatherName"
                                            className="form-control form-text-control"
                                            value={formData.fatherName}
                                            onChange={handleChangename} />

                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Age<span className="mandate_field">*</span></label>
                                        <input
                                            type="number"
                                            min="1"
                                            max="99"
                                            className="form-control form-text-control"
                                            maxLength="2"
                                            value={age}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || (Number(val) >= 1 && Number(val) <= 99)) {
                                                    setAge(val);
                                                }
                                            }}
                                        />

                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Date of Birth</label>
                                        <input type="date"
                                            name="dob"
                                            className="form-control form-text-control"
                                            value={demographicFields.dob}
                                            onChange={handleDemographicChange}
                                        />

                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Gender<span className="mandate_field">*</span></label>
                                        <select className="form-select" name="gender" value={demographicFields.gender} onChange={handleDemographicChange}>
                                            <option value="" disabled>Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Transgender">Transgender</option>
                                        </select>
                                        {!demographicFields.gender && <p className="error">This field is required</p>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Primary Phone<span className="mandate_field">*</span></label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">+91</span>
                                            <input type="text" className="form-control"
                                                name="primary"
                                                value={phones.primary}
                                                onChange={handlePhoneChange}
                                                maxLength="10"
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Secondary Phone 1</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">+91</span>
                                            <input type="text" className="form-control"
                                                name="secondary1"
                                                value={phones.secondary1}
                                                onChange={handlePhoneChange}
                                                maxLength="10"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Secondary Phone 2</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">+91</span>
                                            <input type="text" className="form-control"
                                                name="secondary2"
                                                value={phones.secondary2}
                                                onChange={handlePhoneChange}
                                                maxLength="10"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Secondary Phone 3</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">+91</span>
                                            <input type="text" className="form-control"
                                                name="secondary3"
                                                value={phones.secondary3}
                                                onChange={handlePhoneChange}
                                                maxLength="10"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Residence Details</h5>
                        </div>
                        <div className="nikFeildsBody">
                            <div className="row">
                                <div className="col-xs-12 col-md-6">
                                    <div className="feild">
                                        <label>Address<span className="mandate_field">*</span></label>
                                        <textarea type="text" className="areaAddress form-control"
                                            name="address"
                                            value={addressFields.address}
                                            onChange={handleAddressChange}
                                        />
                                        {/* {!addressFields.address.trim() && <p className="error">This field is required</p>} */}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <div className="row">
                                        <div className="col-xs-12 col-md-12">
                                            <div className="feild">
                                                <label>Taluka/Block <span className="mandate_field">*</span></label>
                                                <input type="text"
                                                    name="taluka"
                                                    className="form-control form-text-control"
                                                    value={addressFields.taluka}
                                                    onChange={handleAddressChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="feild">
                                                <label>Landmark</label>
                                                <input type="text"
                                                    name="landmark"
                                                    className="form-control form-text-control"
                                                    value={addressFields.landmark}
                                                    onChange={handleAddressChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>State<span className="mandate_field">*</span></label>
                                        <select value={selectedState} onChange={handleStateChange}
                                            className="form-select">
                                            <option value="">Select State</option>
                                            {states.map((state) => (
                                                <option key={state.id} value={state.id}>
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>District<span className="mandate_field">*</span></label>
                                        <select
                                            value={selectedDistrict}
                                            onChange={handleDistrictChange}
                                            disabled={!selectedState}
                                            className="form-select"
                                        >
                                            <option value="">Select District</option>
                                            {districts.map((district) => (
                                                <option key={district.id} value={district.id}>
                                                    {district.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>TU <span className="mandate_field">*</span></label>
                                        <select
                                            value={selectedTu}
                                            onChange={handleTuChange}
                                            disabled={!selectedDistrict}
                                            className="form-select"
                                        >
                                            <option value="">Select TU</option>
                                            {tuList.filter(tu => tu.name && tu.name.trim()).map((tu) => (
                                                <option key={tu.id} value={tu.id}>
                                                    {tu.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Health Facility <span className="mandate_field">*</span></label>
                                        <select
                                            name="healthFacility"
                                            value={addressFields.healthFacility}
                                            onChange={handleAddressChange}
                                            disabled={!selectedTu}
                                            className="form-select"
                                        >
                                            <option value="">Select Health Facility</option>
                                            {facilities.filter(facility => facility.name && facility.name.trim()).map((facility) => (
                                                <option key={facility.id} value={facility.id}>
                                                    {facility.name}
                                                </option>
                                            ))}
                                        </select>
                                        {/* {!addressFields.healthFacility && <p className="error">This field is required</p>} */}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Village <span className="mandate_field">*</span></label>
                                        <select name="village"
                                            value={addressFields.village}
                                            onChange={handleAddressChange}
                                            disabled={!addressFields.healthFacility}
                                            className="form-select">
                                            <option value="">Select Village</option>
                                            {villages.map((village) => (
                                                <option key={village.id} value={village.id}>
                                                    {village.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Pincode <span className="mandate_field">*</span></label>
                                        <input type="text"
                                            className="form-control form-text-control"
                                            value={pincode}
                                            onChange={handlePincodeChange}
                                            maxLength="6" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Demographic Details</h5>
                        </div>
                        <div className="nikFeildsBody">
                            <div className="row">
                                {/* Area */}
                                <div className="col-xs-12 col-md-4">
                                    <div className="feild">
                                        <label>Area<span className="mandate_field">*</span></label>
                                        <select className="form-select" name="area" value={demographicFields.area} onChange={handleDemographicChange}>
                                            <option value="Tribal-Non Particularly Vulnerable Tribal Groups">Tribal-Non Particularly Vulnerable Tribal Groups</option>
                                            <option value="Tribal-Particularly Vulnerable Tribal Groups">Tribal-Particularly Vulnerable Tribal Groups</option>
                                            <option value="Rural">Rural</option>
                                            <option value="Urban">Urban</option>
                                            <option value="Urban Slum">Urban Slum</option>
                                            <option value="Unknown">Unknown</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Marital Status */}
                                <div className="col-xs-12 col-md-2">
                                    <div className="feild">
                                        <label>Marital Status<span className="mandate_field">*</span></label>
                                        <select className="form-select" name="maritalStatus" value={demographicFields.maritalStatus} onChange={handleDemographicChange}>
                                            <option value="Single">Single</option>
                                            <option value="Married">Married</option>
                                            <option value="Unknown">Unknown</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Occupation */}
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Occupation<span className="mandate_field">*</span></label>
                                        <select className="form-select" name="occupation" value={demographicFields.occupation} onChange={handleDemographicChange}>
                                            <option value="Unknown">Unknown</option>
                                            <option value="Legislators and Senior officials">Legislators and Senior officials</option>
                                            <option value="Corporate Manager">Corporate Manager</option>
                                            <option value="General Manager">General Manager</option>
                                            <option value="Physical, mathematical and engineering science professional">Physical, mathematical and engineering science professional</option>
                                            <option value="Life sciences and health professional">Life sciences and health professional</option>
                                            <option value="Teaching professional">Teaching professional</option>
                                            <option value="Other professional">Other professional</option>
                                            <option value="Office Clerk">Office Clerk</option>
                                            <option value="Customer Services Clerks">Customer Services Clerks</option>
                                            <option value="Personal Protective Service Providers">Personal Protective Service Providers</option>
                                            <option value="Models, Sales Persons and Demonstrators">Models, Sales Persons and Demonstrators</option>
                                            <option value="Market oriented skilled agriculutre and fishery workers">Market oriented skilled agriculutre and fishery workers</option>
                                            <option value="Subsitence agriculture and fishery workers">Subsitence agriculture and fishery workers</option>
                                            <option value="Extraction and building trade workers">Extraction and building trade workers</option>
                                            <option value="Metal, Machinery and related trades workers">Metal, Machinery and related trades workers</option>
                                            <option value="Precision, handicraft, printing and related trade workers">Precision, handicraft, printing and related trade workers</option>
                                            <option value="Other Craft and related traders and workers">Other Craft and related traders and workers</option>
                                            <option value="Stationary Plant and related Operators">Stationary Plant and related Operators</option>
                                            <option value="Machine Operators and Assembler">Machine Operators and Assembler</option>
                                            <option value="Drivers and Mobile Plant Operators">Drivers and Mobile Plant Operators</option>
                                            <option value="Sales and Services elementry occupations">Sales and Services elementry occupations</option>
                                            <option value="Agriculture, fishery and related labour">Agriculture, fishery and related labour</option>
                                            <option value="Laborers in mining, construction, manufecturing and transport">Laborers in mining, construction, manufecturing and transport</option>
                                            <option value="New Workers seeking employment">New Workers seeking employment</option>
                                            <option value="Workers reporting occupation unidentifiable or inadequately">Workers reporting occupation unidentifiable or inadequately</option>
                                            <option value="Workers no reporting any occupation">Workers no reporting any occupation</option>
                                            <option value="House Wife">House Wife</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Socioeconomic Status */}
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Socioeconomic Status<span className="mandate_field">*</span></label>
                                        <select className="form-select" name="socioeconomicStatus" value={demographicFields.socioeconomicStatus} onChange={handleDemographicChange}>
                                            <option value="APL">APL</option>
                                            <option value="BPL">BPL</option>
                                            <option value="Unknown">Unknown</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Symptoms and Risk Factors</h5>
                        </div>
                        <div className="nikFeildsBody">
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <div className="feild">
                                        <label>Symptoms<span className="mandate_field">*</span></label>
                                        <div className="radioProfile">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_Asymptomatic"
                                                    checked={checkedSymptoms.symptom_Asymptomatic}
                                                    onChange={handleSymptomChange}
                                                    disabled={
                                                        Object.values(checkedSymptoms).some((val, idx) => idx !== 0 && val)
                                                    }
                                                />
                                                <span>Asymptomatic</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_twoWeeks"
                                                    checked={checkedSymptoms.symptom_twoWeeks}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Cough for more than 2 weeks</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_upblood"
                                                    checked={checkedSymptoms.symptom_upblood}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Cough up blood</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_fever"
                                                    checked={checkedSymptoms.symptom_fever}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Fever</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_weightLoss"
                                                    checked={checkedSymptoms.symptom_weightLoss}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Weight Loss</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_chestPain"
                                                    checked={checkedSymptoms.symptom_chestPain}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Chest Pain</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_Shortnessbreath"
                                                    checked={checkedSymptoms.symptom_Shortnessbreath}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Shortness of breath</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_Fatigue"
                                                    checked={checkedSymptoms.symptom_Fatigue}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Fatigue</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_FailureGainWeight"
                                                    checked={checkedSymptoms.symptom_FailureGainWeight}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Failure to gain weight (in children)</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_DecreasedActivity"
                                                    checked={checkedSymptoms.symptom_DecreasedActivity}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Decreased activity or playfulness (in children)</span>
                                            </label>
                                            <label style={{ width: '100%' }}>
                                                <input
                                                    type="checkbox"
                                                    name="symptom_others"
                                                    checked={checkedSymptoms.symptom_others}
                                                    onChange={handleSymptomChange}
                                                    disabled={isAsymptomaticChecked}
                                                />
                                                <span>Others</span>
                                            </label>
                                            <input type="text" name="othersymptomText" className="form-control form-text-control" style={{ width: 200 }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-8">
                                    <div className="feild">
                                        <label>Key Population/Risk factors<span className="mandate_field">*</span></label>
                                        <div className="radioProfile keyPopulationRiskFactors">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="antiTNF"
                                                    value="Anti-TNF treatment"
                                                    checked={checkedItems.antiTNF}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Anti-TNF treatment</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="BronchialAsthma"
                                                    value="Bronchial Asthma"
                                                    checked={checkedItems.BronchialAsthma}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Bronchial Asthma</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Cancer"
                                                    value="Cancer"
                                                    checked={checkedItems.Cancer}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Cancer</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="CardiovascularDiscorder"
                                                    value="Cardiovascular Disorder"
                                                    checked={checkedItems.CardiovascularDiscorder}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Cardiovascular Disorder</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="TBPatients"
                                                    value="Contact of Known TB Patients"
                                                    checked={checkedItems.TBPatients}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Contact of known TB Patients</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="COPD"
                                                    value="COPD"
                                                    checked={checkedItems.COPD}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>COPD</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="covidRecovery"
                                                    value="COVID recovered patients"
                                                    checked={checkedItems.covidRecovery}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>COVID recovered patients</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Diabetes"
                                                    value="Diabetes"
                                                    checked={checkedItems.Diabetes}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Diabetes</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Dialysis"
                                                    value="Dialysis"
                                                    checked={checkedItems.Dialysis}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Dialysis</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="HealthCareWorker"
                                                    value="Health Care Worker"
                                                    checked={checkedItems.HealthCareWorker}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Health Care Worker</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Hypertensive"
                                                    value="Hypertensive"
                                                    checked={checkedItems.Hypertensive}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Hypertensive</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="LactatingMother"
                                                    value="Lactating mother"
                                                    checked={checkedItems.LactatingMother}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked || demographicFields.gender === "Male" || demographicFields.gender === "Transgender"}
                                                />
                                                <span>Lactating Mother</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="LiverImpairment"
                                                    value="Liver Impairment"
                                                    checked={checkedItems.LiverImpairment}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Liver Impairment</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Migrant"
                                                    value="Migrant"
                                                    checked={checkedItems.Migrant}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Migrant</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Miner"
                                                    value="Miner"
                                                    checked={checkedItems.Miner}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Miner</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="PalliativeCare"
                                                    value="Palliative Care"
                                                    checked={checkedItems.PalliativeCare}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Palliative Care</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Patientimmunsuppressants"
                                                    value="Patient on immunosuppressants"
                                                    checked={checkedItems.Patientimmunsuppressants}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Patient on immunosuppressants</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Preanancv"
                                                    value="Pregnancy"
                                                    checked={checkedItems.Preanancv}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked || demographicFields.gender === "Male" || demographicFields.gender === "Transgender"}
                                                />
                                                <span>Pregnancy</span>
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Prison"
                                                    value="Prison"
                                                    checked={checkedItems.Prison}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Prison</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="IllegalImmigrant"
                                                    value="Illegal Immigrant"
                                                    checked={checkedItems.IllegalImmigrant}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Illegal Immigrant</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="RenalImpairment"
                                                    value="Rental Impairment"
                                                    checked={checkedItems.RenalImpairment}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Renal Impairment</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Transplantation"
                                                    value="Transplantation"
                                                    checked={checkedItems.Transplantation}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Transplantation</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="UrbanSlum"
                                                    value="Urban Slum"
                                                    checked={checkedItems.UrbanSlum}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Urban Slum</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="BCGVaccination"
                                                    value="H/o Adult BCG Vaccination"
                                                    checked={checkedItems.BCGVaccination}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>H/o Adult BCG Vaccination</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Undernourished"
                                                    value="Undernourished / Malnourished (BMI <18.5 kg/m2)"
                                                    checked={checkedItems.Undernourished}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Undernourished/Malnourished (BMI &lt; 18.5 kg/m²)</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Elderly"
                                                    value="Elderly (age >60 years)"
                                                    checked={checkedItems.Elderly}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Elderly (age &gt; 60 years)</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="WorkplaceSettings"
                                                    value="Workplace settings (coal/ sandblasting/ brick kiln)"
                                                    checked={checkedItems.WorkplaceSettings}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Workplace settings (coal/sandblasting/brick kiln)</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="TeaGardenWorker"
                                                    value="Tea garden worker"
                                                    checked={checkedItems.TeaGardenWorker}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Tea garden worker</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="ConstructionSiteWorker"
                                                    value="Construction site worker"
                                                    checked={checkedItems.ConstructionSiteWorker}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Construction site worker</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="CongregateSettings"
                                                    value="Congregate settings"
                                                    checked={checkedItems.CongregateSettings}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Congregate settings</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="DeaddictionCenters"
                                                    value="Attendees of de-addiction centers"
                                                    checked={checkedItems.DeaddictionCenters}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Attendees of de-addiction centers</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="IndoorPollution"
                                                    value="Person exposed to indoor air pollution"
                                                    checked={checkedItems.IndoorPollution}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Person exposed to indoor air pollution</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="MarginalizedHIV"
                                                    value="Marginalized populations at risk of HIV"
                                                    checked={checkedItems.MarginalizedHIV}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Marginalized populations at risk of HIV</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="LGBTQAI"
                                                    value="LGBTQAI++"
                                                    checked={checkedItems.LGBTQAI}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>LGBTQAI++</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="SubstanceAbuse"
                                                    value="Substance abuse (alcoholic/intravenous drug users)"
                                                    checked={checkedItems.SubstanceAbuse}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Substance abuse (alcoholic/intravenous drug users)</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="TobaccoSmoker"
                                                    value="Tobacco/smoker"
                                                    checked={checkedItems.TobaccoSmoker}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Tobacco/smoker</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="SilicaExposure"
                                                    value="Silica exposure/silicosis"
                                                    checked={checkedItems.SilicaExposure}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Silica exposure / Silicosis</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="Other"
                                                    value="Other"
                                                    checked={checkedItems.Other}
                                                    onChange={handleChange}
                                                    disabled={isNotApplicableChecked}
                                                />
                                                <span>Other</span>
                                            </label>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="NotApplicable"
                                                    value="Not Applicable"
                                                    checked={checkedItems.NotApplicable}
                                                    onChange={handleChange}
                                                    disabled={anyOtherChecked}
                                                />
                                                <span>Not Applicable</span>
                                            </label>
                                            {checkedItems.BCGVaccination && (
                                                <label style={{ width: '100%' }}>
                                                    <span style={{ width: '20%' }}>Vaccination Date<span className="mandate_field">*</span></span>
                                                    <input
                                                        type="date"
                                                        className="form-control form-text-control"
                                                        value={vaccinationDate}
                                                        onChange={(e) => setVaccinationDate(e.target.value)}
                                                        max={new Date().toISOString().split('T')[0]}
                                                        style={{ marginTop: '5px' }}
                                                    />
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>HIV Status<span className="mandate_field">*</span></label>
                                        <select value={hivStatus} onChange={(e) => setHivStatus(e.target.value)}>
                                            <option value="">-Select Status-</option>
                                            <option value="Positive">Positive</option>
                                            <option value="Reactive">Reactive</option>
                                            <option value="Non-Reactive">Non Reactive/Negative</option>
                                            <option value="Unknown">Unknown</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Contact Person Details</h5>
                        </div>
                        <div className="nikFeildsBody">
                            <div className="row">
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Contact Person Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control form-text-control"
                                            value={contactPerson.name}
                                            onChange={handleContactPersonChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Contact Person Phone</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">+91</span>
                                            <input
                                                type="text"
                                                name="phone"
                                                value={contactPerson.phone}
                                                onChange={handleContactPersonChange}
                                                className="form-control form-control form-text-control"
                                                placeholder=""
                                                aria-label="Username"
                                                aria-describedby="basic-addon1"
                                                maxLength="10"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Contact Person Address</label>
                                        <input
                                            type="text"
                                            name="address"
                                            className="form-control form-text-control"
                                            value={contactPerson.address}
                                            onChange={handleContactPersonChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feildsSection">
                        <div className="nikFeildsSectionHeader">
                            <h5>Informant Details</h5>
                        </div>
                        <div className="nikFeildsBody">
                            <div className="row">
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Informant Name</label>
                                        <input type="text"
                                            name="name"
                                            className="form-control form-text-control"
                                            value={informant.name}
                                            onChange={handleInformantChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <div className="feild">
                                        <label>Designation</label>
                                        <input type="text"
                                            name="designation"
                                            className="form-control form-text-control"
                                            value={informant.designation}
                                            onChange={handleInformantChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="newRegaddBtnValue">
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Processing..." : "Add case"}
                        </button>
                    </div>
                </form>
            </div>

            {showPhiModal && (
                <div className="phi-modal-backdrop" onClick={() => setShowPhiModal(false)}>
                    <div className="phi-modal-container" onClick={(e) => e.stopPropagation()}>
                        <div className="phi-modal-header">
                            <h5 className="phi-modal-title">{personFrom === "IndiaTbPublic" ? "Select Public PHI" : "Select Private Facility"}</h5>
                            <button type="button" className="phi-modal-close-btn" onClick={() => setShowPhiModal(false)}>
                                &times;
                            </button>
                        </div>
                        <div className="phi-modal-body">
                            {/* State */}
                            <div className="phi-form-row">
                                <label className="phi-form-label">State</label>
                                <div className="phi-form-control-wrapper">
                                    <select
                                        value={tempState}
                                        onChange={handleTempStateChange}
                                        className="form-select phi-form-select"
                                    >
                                        <option value="">Select State</option>
                                        {states.map((state) => (
                                            <option key={state.id} value={state.id}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* District */}
                            <div className="phi-form-row">
                                <label className="phi-form-label">District</label>
                                <div className="phi-form-control-wrapper">
                                    <select
                                        value={tempDistrict}
                                        onChange={handleTempDistrictChange}
                                        disabled={!tempState}
                                        className="form-select phi-form-select"
                                    >
                                        <option value="">Select District</option>
                                        {tempDistricts.map((district) => (
                                            <option key={district.id} value={district.id}>
                                                {district.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* TU */}
                            <div className="phi-form-row">
                                <label className="phi-form-label">TU</label>
                                <div className="phi-form-control-wrapper">
                                    <select
                                        value={tempTu}
                                        onChange={handleTempTuChange}
                                        disabled={!tempDistrict}
                                        className="form-select phi-form-select"
                                    >
                                        <option value="">Select TU</option>
                                        {tempTuList.filter(tu => tu.name && tu.name.trim()).map((tu) => (
                                            <option key={tu.id} value={tu.id}>
                                                {tu.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="phi-form-row">
                                <label className="phi-form-label">{personFrom === "IndiaTbPublic" ? "PHI" : "Private HF"} <span className="mandate_field">*</span></label>
                                <div className="phi-form-control-wrapper">
                                    <select
                                        name="healthFacility"
                                        value={tempHealthFacility}
                                        onChange={handleTempPhiChange}
                                        disabled={!tempTu}
                                        className="form-select phi-form-select"
                                    >
                                        <option value="">Select {personFrom === "IndiaTbPublic" ? "PHI" : "Private HF"}</option>

                                        {tempFacilities
                                            .filter(
                                                facility =>
                                                    facility.name?.trim() &&
                                                    (
                                                        personFrom === "IndiaTbPublic" ? facility.type === "PHI" : facility.type !== "PHI"
                                                    )
                                            ).sort((a, b) => {
                                                return Number(a.code) - Number(b.code);
                                            })
                                            .map((facility) => (
                                                <option key={facility.id} value={facility.id}>
                                                    {facility.name} ({facility.code})
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="phi-modal-footer">
                            <button type="button" className="phi-btn-done" onClick={handlePhiModalDone}>
                                Done
                            </button>
                            <button type="button" className="phi-btn-close" onClick={() => setShowPhiModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default NewRegistrationNikshay;